<template>
  <div>
    <me-action-sheet
      :value="sheetShow"
      :class="'action-title'"
      @cancel="onCancel"
      @click-overlay="onCancel"
      :closeable="false"
      :title="`${curItem.pageName}`"
    >
      <me-row class="action-sheet">
        <me-col span="6">
          <div class="action-item" @click="edit">
            <div class="icon">
              <me-icon name="edit" size="24" />
            </div>
            <div class="txt">编辑</div>
          </div>
        </me-col>
        <me-col span="6" v-if="curItem.pageStatus === 'Published'">
          <div class="action-item" @click="stop">
            <div class="icon">
              <me-icon name="pause-circle-o" size="24" />
            </div>
            <div class="txt">暂停</div>
          </div>
        </me-col>
        <me-col span="6" v-else>
          <div class="action-item" @click="publish()">
            <div class="icon">
              <me-icon name="play-circle-o" size="24" />
            </div>
            <div class="txt">发布</div>
          </div>
        </me-col>
        <me-col span="6">
          <div class="action-item" @click="share">
            <div class="icon">
              <me-icon name="share-o" size="24" />
            </div>
            <div class="txt">分享</div>
          </div>
        </me-col>
        <me-col span="6">
          <div class="action-item" @click="analysic">
            <div class="icon">
              <me-icon name="bar-chart-o" size="24" />
            </div>
            <div class="txt">数据</div>
          </div>
        </me-col>
        <me-col span="6">
          <div class="action-item" @click="copy">
            <div class="icon">
              <me-icon name="notes-o" size="24" />
            </div>
            <div class="txt">复制</div>
          </div>
        </me-col>
        <me-col span="6">
          <div class="action-item" @click="del">
            <div class="icon">
              <me-icon name="delete-o" size="24" />
            </div>
            <div class="txt">删除</div>
          </div>
        </me-col>
        <me-col span="6">
          <div class="action-item" @click="notice">
            <div class="icon">
              <me-icon name="comment-o" size="24" />
            </div>
            <div class="txt">通知</div>
          </div>
        </me-col>
        <!-- <me-col span="6">
          <div class="action-item" @click="save">
            <div class="icon">
              <me-icon name="share-o" size="24" />
            </div>
            <div class="txt">存为模版</div>
          </div>
        </me-col> -->
      </me-row>
      <me-button block class="close-btn" @click="onCancel">关闭</me-button>
    </me-action-sheet>
  </div>
</template>
<script>
import { Toast } from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { addClass2, removeClass2 } from '@/util/status-util'
import TemplateSave from './save.vue'

export default {
    props: {
        sheetShow: {
            type: Boolean,
            default: false,
        },
        curItem: {
            type: Object,
            default: () => {},
        },
        list: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
          createSheetShow: false
        }
    },
    computed: {
        requestData() {
            return {
                tid: this.tid,
                pageId: this.curItem.pageId,
            }
        },
    },
    components: {
      TemplateSave
    },
    methods: {
        save() {
          this.createSheetShow = true
        },
        cancelSheetShow() {
            this.createSheetShow = false
            this.$store.commit('removeRangeList')
            this.$store.commit('updateLabelNames', [])
            this.$store.commit('removeTemplateData')
        },
        edit() {
          this.$store.commit('updateShowJson', '')
          this.$store.commit('updateShowConfirm', false)
          this.$store.commit('updateSkipObj', null)
          this.$store.commit('removeRangeList')
          this.$store.commit('updateLabelNames', [])
          this.$store.commit('removeTemplateData')
          this.$router.push({
              name: 'edit',
              params: {
                  pageId: this.curItem.pageId,
              },
          })
        },
        publish(msg) {
            // const questionPublish = () => {
            //     addClass2('body', 'loading')
            //     Questionnaire.questionPublish(this.requestData).then((res) => {
            //         removeClass2('body', 'loading')
            //         if (res.data.code == 'S00000') {
            //             this.$emit('reflesh')
            //             const opts = {
            //                 message: '发布成功，是否立即分享？',
            //                 confirmFn: () => {
            //                     this.curItem.pageStatus = 'Published'
            //                     this.share()
            //                 },
            //                 cancelFn: () => {
            //                     console.log('cancelFn')
            //                 },
            //             }
            //             this.$_dialog(opts)
            //         }
            //     }).catch((error) => {
            //         removeClass2('body', 'loading')
            //         console.log(error.response)
            //         Toast.fail(error.response.data.message)
            //     })
            // }
            // if (!msg) {
            //     questionPublish()
            //     return
            // }
            // const options = {
            //     title: '提示',
            //     message: msg || '发布问卷',
            //     confirmFn: () => {
            //         questionPublish()
            //     },
            // }
            // this.$_dialog(options)
            this.$router.push({
                name: 'publish',
                params: {
                    pageId: this.curItem.pageId,
                },
            })
        },
        stop() {
            const options = {
                title: '提示',
                message: '暂停后问卷将无法填写，确定吗？',
                confirmFn: () => {
                    addClass2('body', 'loading')
                    Questionnaire.questionStop(this.requestData).then((res) => {
                        removeClass2('body', 'loading')
                        if (res.data.code == 'S00000') {
                            Toast.success('问卷已暂停')
                            this.$emit('reflesh')
                        }
                    }).catch((error) => {
                        removeClass2('body', 'loading')
                        console.log(error.response)
                        Toast.fail(error.response.data.message)
                    })
                },
            }
            this.$_dialog(options)
        },
        copy() {
            const options = {
                title: '',
                message: '复制问卷',
                confirmFn: () => {
                    addClass2('body', 'loading')
                    Questionnaire.questionCopy(this.requestData).then((res) => {
                        removeClass2('body', 'loading')
                        if (res.data.code == 'S00000') {
                            this.$emit('reflesh')
                        }
                    }).catch((error) => {
                        removeClass2('body', 'loading')
                        console.log(error.response)
                        Toast.fail(error.response.data.message)
                    })
                },
            }
            this.$_dialog(options)
        },
        share() {
            // 还未发布 提示去发布
            if (this.curItem.pageStatus == 'Unpublished') {
                const msg = '此问卷还未发布，确认发布吗？'
                this.publish(msg)
                return
            }
            this.$router.push({
                name: 'share',
                params: {
                    pageId: this.curItem.pageId,
                },
            })
        },
        analysic() {
            // 暂停后、且答卷数不为0时，可直接查看数据结果 :仍提示问卷未发布
            if (this.curItem.pageStatus == 'Unpublished' && this.curItem.answerCount === 0) {
                Toast.fail('此问卷还未发布,暂无数据')
                return
            }
            this.$router.push({
                name: 'data',
                params: {
                    pageId: this.curItem.pageId,
                },
            })
        },
        del() {
            const options = {
                message: '您确定要删除这个问卷吗？',
                confirmFn: () => {
                    addClass2('body', 'loading')
                    const data = {
                        tid: this.tid,
                        pageId: this.curItem.pageId,
                    }
                    Questionnaire.questionDelete(data).then(
                        (res) => {
                            removeClass2('body', 'loading')
                            if (res.data.code == 'S00000') {
                                this.$emit('reflesh')
                                Toast.success('删除成功')
                            }
                        },
                    ).catch((error) => {
                        removeClass2('body', 'loading')
                        console.log(error.response)
                        Toast.fail(error.response.data.message)
                    })
                },
            }
            this.$_dialog(options)
        },
        notice() {
          this.$router.push({
            name: 'notice',
            params: {
                pageId: this.curItem.pageId,
            },
          })
        },
        onCancel() {
            this.$emit('cancel')
        },
    },
}
</script>
<style lang="scss" scoped>
.me-action-sheet__header {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  word-wrap: break-word;
  width: 80%;
  margin: 0 auto;
  color: #9298A8;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.action-sheet {

  border-top: 0.5px solid #F2F4F6;
  margin-bottom: 10px;

  > .me-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .action-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px;
      .icon {
        width: 24px;
        height: 24px;
      }
      .txt {
        margin-top: 10px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
  .close-btn{
      border: none;
  }
}
.me-button--default{
  border: none;
  background: #F2F4F6;
}
.me-loading {
  position: absolute;
  z-index: 9000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
